function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import FeedbackContent from './FeedbackContent';
import useFeedbackPanel from './useFeedbackPanel';
/**
 * Layout sets up the basic layout for the explorer.
 * @param Object children Child elements
 * @param Object props    Props passed from parent
 */

var FeedbackModal = function FeedbackModal(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  var _useFeedbackPanel = useFeedbackPanel(),
      toggleFeedback = _useFeedbackPanel.toggleFeedback,
      show = _useFeedbackPanel.feedbackState.show;

  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: show,
    toggle: toggleFeedback,
    className: "feedback-modal bs-expl",
    backdrop: true,
    keyboard: true,
    autoFocus: true,
    centered: true
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    toggle: toggleFeedback
  }), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(FeedbackContent, null)));
};

export default FeedbackModal;